import React from "react";

// This app runs on React 17, which has no `React.useId`. Most Nova
// (`@hxnova/react-components`) components route id generation through the
// React-17-safe `@mui/utils` `unstable_useId` fallback, but a few — notably
// `Radio` — call `React.useId()` directly and therefore crash on React 17.
//
// We install a guarded shim: a real hook (one `useState` call, so it obeys the
// rules of hooks and stays stable across re-renders) that hands back a unique id
// per mount. It is only installed when `React.useId` is missing, so it becomes an
// inert no-op once the app upgrades to React 18+ (which ships a native `useId`).
//
// Import this module for its side effect once, as early as possible, before any
// Nova component renders (the app entry point and the test setup both do so).

const reactWithUseId = React as typeof React & { useId?: () => string };

if (typeof reactWithUseId.useId !== "function") {
  let nextId = 0;
  reactWithUseId.useId = function useIdPolyfill(): string {
    const [id] = React.useState(() => `nova-useid-${(nextId += 1)}`);
    return id;
  };
}
